import React from 'react';
import {connect} from 'react-redux';
import ReportItem from '../ReportItem/ReportItem.js';
import HoleItem from '../HoleItem/HoleItem.js';
import * as Constants from "../../Common/constants";
export class LastReportWidget extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = { serverErrors: {}};
       
        
        console.info('LastReportWidget - constructor called.');
    }

    componentWillMount() {
        console.info('LastReportWidget - componentWillMount called.');
    }

    componentDidMount() {
        console.info('LastReportWidget - componentDidMount called.');
        
    }

    componentWillReceiveProps(nextProps) {
        console.info('LastReportWidget - componentWillReceiveProps called.');
       
        if (nextProps.lastitem){
        this.loadPlayerEvents(nextProps.lastitem.playerid, nextProps.lastitem.holeindex);
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {
       
    }


    render() {
        console.info('LastReportWidget - render called.');
        var item = this.props.lastitem;
        if (!item){
            
            item = {};
            item.timeinms = 1537302599412;
            item.playerid = 1;
            item.uuid= "692F55EE-D80E-4A18-8D47-126D1C3D4606";
            item.holeindex =  2;
            item.strokeindex =3;
            item.playername="Player 1";
            item.reporter = "692F55EE-D80E-4A18-8D47-126D1C3D4606";
            item.result =0;
            item.status = "Preparing to hit";
            //this.loadPlayerEvents(item.playerid,  item.holeindex);
           
        }
        if (item){
            return this.renderLastItem(item);
        }else {
            return this.renderEmptyState();
        }    
    }

    renderLastItem(item){
        return (
            <div>
                <h2>Last report </h2>
               <ReportItem data={item} />
               <HoleItem holeindex={item.holeindex} strokes={this.state.strokes}/>
            </div>
        );
    }

    renderEmptyState(){
        return (
            <div>
              Waiting for report...
            </div>
        );
    }
    
    loadPlayerEvents(playerid, holeindex){
        console.log("Load Player Events");
        var url = Constants.SERVER + "/playerevents/" + Constants.LEADERBOARD_ID + "/" +playerid + "/" + holeindex;
        var component = this;
        fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(playerevents) {
            console.log("Load Player setState");
            let strokes = getStrokes(playerevents);
            component.setState({
                strokes: strokes
             })
          
        });
        
    }
}

function getStrokes(events){
    var strokes = [];
    events.forEach(element => {
        if (element.type === Constants.EVENT_TYPE_STROKE){
            let stroke = JSON.parse(element.value);
            strokes.unshift(stroke); 
        }
    });

    return strokes;
}
/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    lastitem: state.leaderboard.last
});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {
   
};

export default connect(mapStateToProps, mapActionsToProps)(LastReportWidget);



// WEBPACK FOOTER //
// ./src/Components/LastReportWidget/LastReportWidget.js